var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#044aac",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.082 17.21l-2.618 2.62-1.23 1.23A10.937 10.937 0 015 16C5 9.935 9.935 5 16 5s11 4.935 11 11-4.935 11-11 11c-2.346 0-4.522-.739-6.31-1.995a11.08 11.08 0 01-1.277-1.047l1.162-1.163 8.417-8.417a1.621 1.621 0 011.614-1.49 1.62 1.62 0 011.61 1.455l3.874 3.874A9.346 9.346 0 0025.356 16c0-5.16-4.197-9.356-9.356-9.356S6.644 10.84 6.644 16c0 .718.081 1.417.235 2.089L9.367 15.6a1.621 1.621 0 011.599-1.365 1.62 1.62 0 011.593 1.334l1.583 1.582-1.163 1.162-1.114-1.114a1.61 1.61 0 01-1.783.01zm8.709-1.306l-7.918 7.918A9.301 9.301 0 0016 25.356c3.753 0 6.997-2.221 8.486-5.418l-4.045-4.046a1.609 1.609 0 01-1.65.012zm.844-2.116a.728.728 0 10.002 1.455.728.728 0 00-.002-1.455zm-8.66 1.327a.728.728 0 100 1.456.728.728 0 000-1.456z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvx);
export default __webpack_public_path__ + "static/media/evx.0a4d9f6455f083b2019a7bc02edf352a.svg";
export { ForwardRef as ReactComponent };